import { PAGE_TYPE } from "@supplier/meta";
import { RouteRecordRaw } from "vue-router";

const salesManageRouter: RouteRecordRaw[] = [
    {
        path: "salesManage",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/salesManage/order",
        name: "SalesManage",
        meta: {
            title: "销售管理"
        },
        children: [
            {
                path: "order",
                name: "SalesOrderManagement",
                component: () => import("@/views/pages/salesManagement/orderManagement/index.vue"),
                meta: {
                    title: "订单管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "order/add",
                name: "SalesOrderAdd",
                component: () => import("@/views/pages/salesManagement/orderManagement/form.vue"),
                meta: {
                    title: "新增订单",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SalesOrderManagement",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "order/edit/:id",
                name: "SalesOrderEdit",
                component: () => import("@/views/pages/salesManagement/orderManagement/form.vue"),
                meta: {
                    title: "修改订单",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "SalesOrderManagement",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "order/:id",
                name: "SalesOrderInfo",
                component: () => import("@/views/pages/salesManagement/orderManagement/details.vue"),
                meta: {
                    title: "订单详情",
                    hidden: true,
                    customize: true,
                    pageType: PAGE_TYPE.LOG.code,
                    activeMenu: "SalesOrderManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ],
                    isNotShowHeader: true
                }
            },
            {
                path: "delivery",
                name: "Delivery",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/index.vue"),
                meta: {
                    title: "发货管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "deliveryDetail",
                name: "DeliveryDetail",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/detail.vue"),
                meta: {
                    title: "发货详情",
                    activeMenu: "Delivery",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "deliveryAdd",
                name: "DeliveryAdd",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/form.vue"),
                meta: {
                    title: "新增发货",
                    activeMenu: "Delivery",
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "deliveryEdit",
                name: "DeliveryEdit",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/form.vue"),
                meta: {
                    title: "修改发货",
                    activeMenu: "Delivery",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt",
                name: "SaleReceipt",
                component: () => import("@/views/pages/salesManagement/receiptManagement/index.vue"),
                meta: {
                    title: "签收管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt/add",
                name: "SaleReceiptAdd",
                component: () => import("@/views/pages/salesManagement/receiptManagement/form/index.vue"),
                meta: {
                    title: "新增签收",
                    activeMenu: "SaleReceipt",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt/edit/:id",
                name: "SaleReceiptEdit",
                component: () => import("@/views/pages/salesManagement/receiptManagement/form/index.vue"),
                meta: {
                    title: "修改签收",
                    activeMenu: "SaleReceipt",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt/detail/:id",
                name: "SaleReceiptInfo",
                component: () => import("@/views/pages/salesManagement/receiptManagement/detail.vue"),
                meta: {
                    title: "签收详情",
                    activeMenu: "SaleReceipt",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation",
                name: "SaleReconciliation",
                component: () => import("@/views/pages/salesManagement/reconciliation/index.vue"),
                meta: {
                    title: "结算管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation/add",
                name: "SaleReconciliationAdd",
                component: () => import("@/views/pages/salesManagement/reconciliation/form.vue"),
                meta: {
                    title: "新增结算",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SaleReconciliation",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation/edit/:id",
                name: "SaleReconciliationEdit",
                component: () => import("@/views/pages/salesManagement/reconciliation/form.vue"),
                meta: {
                    title: "修改结算",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "SaleReconciliation",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation/:id",
                name: "SaleReconciliationInfo",
                component: () => import("@/views/pages/salesManagement/reconciliation/details.vue"),
                meta: {
                    title: "结算详情",
                    hidden: true,
                    customize: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "SaleReconciliation",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ],
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default salesManageRouter;
